import { render, staticRenderFns } from "./categoryDetail.vue?vue&type=template&id=341e6eb0&scoped=true"
import script from "./categoryDetail.vue?vue&type=script&lang=js"
export * from "./categoryDetail.vue?vue&type=script&lang=js"
import style0 from "./categoryDetail.vue?vue&type=style&index=0&id=341e6eb0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "341e6eb0",
  null
  
)

export default component.exports